import { defineMessages } from 'react-intl';

export default defineMessages({
  product_card_one_day: {
    id:
      'app.modules.shopDetails.PreferredDishes.PreferredDishesSwimlane.preferredDishesTitle.ProductCard.oneDay',
    defaultMessage: 'Hace {elapsedTime} día',
  },
  product_card_more_days: {
    id:
      'app.modules.shopDetails.PreferredDishes.PreferredDishesSwimlane.preferredDishesTitle.ProductCard.moreDays',
    defaultMessage: 'Hace {elapsedTime} días',
  },
});
